import React, { useEffect, useState } from "react";
import { db, collection, getDocs } from "../firebaseConfig";
import useAuthRedirect from "../hooks/useAuthRedirect";
import "../styles/AdminReviewPage.scss";

interface Submission {
  id: string;
  name: string;
  email: string;
  message: string;
  digitals: string[];
  timestamp: any;
}

const AdminReviewPage: React.FC = () => {
  const { loading } = useAuthRedirect();

  const [submissions, setSubmissions] = useState<Submission[]>([]);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const fetchSubmissions = async () => {
      try {
        const submissionsRef = collection(db, "submissions");
        const snapshot = await getDocs(submissionsRef);

        const data = snapshot.docs.map((doc) => {
          const submission = doc.data();
          return {
            id: doc.id,
            name: submission.name,
            email: submission.email,
            message: submission.message,
            timestamp: submission.submittedAt || submission.timestamp, // fallback just in case
            digitals: submission.imageUrls || [], // 🔁 fix here
          };
        }) as Submission[];

        // Sort by newest first
        const sorted = data.sort(
          (a, b) => b.timestamp?.seconds - a.timestamp?.seconds
        );

        setSubmissions(sorted);
      } catch (error) {
        console.error("Error fetching submissions:", error);
      }
    };

    fetchSubmissions();
  }, []);

  const filteredSubmissions = submissions.filter((submission) =>
    submission.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) return <p>Loading admin access...</p>;

  return (
    <div className="admin-review-container">
      <h2>Model Submissions</h2>

      <input
        type="text"
        placeholder="Search by name..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="search-input"
      />

      {filteredSubmissions.length === 0 ? (
        <p>No submissions found.</p>
      ) : (
        filteredSubmissions.map((submission) => (
          <div className="submission-card" key={submission.id}>
            <div className="info">
              <p><strong>Name:</strong> {submission.name}</p>
              <p><strong>Email:</strong> {submission.email}</p>
              <p><strong>Message:</strong> {submission.message}</p>
              {submission.timestamp && (
                <p>
                  <strong>Submitted:</strong>{" "}
                  {new Date(submission.timestamp.seconds * 1000).toLocaleString()}
                </p>
              )}
            </div>

            <div className="digitals-preview">
              {(submission.digitals ?? []).map((url, index) => (
                <a href={url} target="_blank" rel="noopener noreferrer" key={index}>
                  <img src={url} alt={`Digital ${index + 1}`} />
                </a>
              ))}
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default AdminReviewPage;
